export function initEkonsilioChat() {

    if (window.eK && window.eK.initializing) {
        return;
    }
    const script = document.createElement("script");
    script.src = `https://livechat.ekonsilio.io/62b973be62b85500086b33cd.js`;
    // script.async = true;
    // script.defer = true;
    script.crossorigin = "anonymous";
    document.head.appendChild(script);

}

let chatLoaded = false;
let userInteracted = false;

export function onUserInteract() {
    if (userInteracted) return;
    userInteracted = true;
    try {
        // Inizializza
        initEkonsilioChat();
        chatLoaded = true;
    } catch (error) {
        console.error(" Errore caricamento chat:", error);
    }
    window.removeEventListener("scroll", onUserInteract);
    // window.removeEventListener("keydown", onUserInteract);
    // window.removeEventListener("click", onUserInteract);
}

export function observerUserChat() {
    window.addEventListener("scroll", onUserInteract);
    // window.addEventListener("keydown", onUserInteract);
    // window.addEventListener("click", onUserInteract);
}
